import { Component } from '@angular/core';
import { NavParams, PopoverController, ViewController, AlertController } from 'ionic-angular';

import { AlertService } from '../../../providers/alert-service';
import { ControlesInternosService } from '../../../providers/controles-internos-service';
import { PopoverOptions } from "ionic-angular/components/popover/popover-options";
import { PopoverAssinantesPage } from "../../popovers/popover-assinantes";
import { AGORA } from "../../../app/AGORA";
import { UsuarioService } from "../../../providers/usuario-service";
import { GestaoPcaService } from "../../../providers/gestao-pca-service";
import { OpcoesAssinatura } from '../../../assinatura/opcoes-assinatura.model';
import { environment } from '../../../environments/environment';

/*
  Generated class for the ModalListaEvidencia page.

  See http://ionicframework.com/docs/v2/components/#navigation for more info on
  Ionic pages and navigation.
*/
@Component({
  selector: 'page-modal-lista-evidencia',
  templateUrl: 'modal-lista-evidencia.html',
  providers: [
    ControlesInternosService,
    AGORA
  ]
})
export class ModalListaEvidenciaPage {
  PCAAtiva: any;
  objeto: any;
  titulo: any;
  questaoId: any;
  idQuestaoResposta: any;
  isJurisdicionado: any;
  usuarioLogado: any;
  isCGE: any;
  loading: any = false;

  opcoes: OpcoesAssinatura;

  constructor(
    public AGORA: AGORA,
    public alertCtrl: AlertController,
    private alertService: AlertService,
    private viewCtrl: ViewController,
    public navParams: NavParams,
    public popoverCtrl: PopoverController,
    public controlesInternosService: ControlesInternosService,
    public gestaoPcaService: GestaoPcaService,
    public usuarioService: UsuarioService) {
    this.titulo = this.navParams.get('param1');
    this.objeto = this.navParams.get('param2');
    this.questaoId = this.navParams.get('param3').idQuestao;
    this.idQuestaoResposta = this.navParams.get('param3').idQuestaoResposta;
    this.isJurisdicionado = this.navParams.get('jurisdicionado');
    this.isCGE = this.navParams.get('isCGE');
    this.PCAAtiva = this.gestaoPcaService.getPCA();
    this.PCAAtiva.isPCAAberta = this.gestaoPcaService.isPCAAberta();
    this.usuarioLogado = this.usuarioService.obtemUsuario();

    this.carregarListaArquivoEvidencia(this.idQuestaoResposta);

    this.inicarOpcoesAssinatura();
  }

  private carregarListaArquivoEvidencia(idQuestaoResposta: any) {

    this.loading = true;

    this.controlesInternosService.carregarListaArquivoEvidencia(idQuestaoResposta).subscribe(data => {
      if(data) {
        this.objeto = data;
        this.loading = false;
      }
    }, error => {
      this.objeto = [];
      this.loading = false;
      console.log(error.mensagem);
    });
  }

  mostrarAlerta(titulo, subtitulo) {
    let alert = this.alertCtrl.create({
      title: titulo,
      subTitle: subtitulo,
      buttons: ['Confirmar']
    });
    alert.present();
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }

  fileChange(event, questaoId, idQuestaoResposta) {
    this.alertService.mostraModalConfirmacao("Salvar Arquivo", "Você tem certeza que deseja salvar o arquivo?",
      retornoModal => {
        if (retornoModal) {

          let fileList: FileList = event.target.files;
          if (fileList.length > 0) {
            let file: File = fileList[0];

            if (file.size <= 10485760) {
              this.controlesInternosService.enviarArquivoEvidencia(event, questaoId, idQuestaoResposta).subscribe(data => {
                // this.objeto.push(data);
                this.carregarListaArquivoEvidencia(this.idQuestaoResposta);
                this.mostrarAlerta('Arquivo enviado com sucesso.', '');
                event.target.value = '';
              }, error => {
                console.log(error);
                this.mostrarAlerta('Erro ao salvar o arquivo', error.mensagem);
                event.target.value = '';
              });
            } else {
              this.alertService.mostraAlerta("", "Arquivo ultrapassou o limite de tamanho de 10Mb.");
            }
          }

          
        }
      }
    );
  }

  salvarJustificativa() {
    this.viewCtrl.dismiss(this.objeto);
  }

  deletarArquivo(jsonArquivo) {
    // console.log(JSON.stringify(jsonArquivo));

    this.alertService.mostraModalConfirmacao("Deletar Arquivo", "Você tem certeza que deseja deletar o arquivo " + jsonArquivo.nmArquivo + "?",
      retornoModal => {
        if (retornoModal) {
          this.controlesInternosService.deletarArquivoEvidencia(jsonArquivo).subscribe(data => {
           /*  var i = this.objeto.indexOf(jsonArquivo);
            if (i != -1) {
              this.objeto.splice(i, 1);
            } */
            this.carregarListaArquivoEvidencia(this.idQuestaoResposta);
            this.mostrarAlerta("Arquivo deletado com sucesso.", "");
          }, error => {
            console.log(error);
            this.mostrarAlerta('Erro ao excluir o arquivo', error.mensagem);
          });

        }
      }
    );
  }

  baixarArquivo(urlArquivo) {
    this.loading = true;
    this.controlesInternosService.baixarArquivoEvidencia(urlArquivo);
    this.loading = false;
  }

 /*  assinarArquivos(arquivo) {
    console.log(this.objeto);
    // Assinar arquivo
    let assinar = this.AGORA.assinarArquivosEvidencia(arquivo.idArquivo, this.PCAAtiva.id, this.usuarioLogado.dadosUsuario[0].cpf, this.usuarioService.obterDadosUsuario().perfil);
    assinar.subscribe(
      next => {
        console.log('Sucesso: %s', next);
        this.dismiss();
      },
      error => {
        console.log('Erro: %s', error);
        this.dismiss();
        this.alertService.mostraAlerta("Erro encontrado", error);
      });
  } */

  exibirAssinantes(myEvent, assinantes) {

    let options: PopoverOptions = {
      cssClass: "popover-assinantes",
      showBackdrop: false,
      enableBackdropDismiss: false
    };

    let popover = this.popoverCtrl.create(PopoverAssinantesPage, { assinantes: assinantes }, options);
    popover.present({
      ev: myEvent
    });
  }

  inicarOpcoesAssinatura() {

    const cpf = environment.production ? this.usuarioLogado.dadosUsuario[0].cpf : environment.cpfAssinateTeste;

    this.opcoes = {
      arquivos: [],
      cpfUsuarioLogado: cpf,
      urlBackEndCallBack: environment.urlBackEndCallBackAssinatura,
      dadosBackEndCallBack: [],
      idPca: this.PCAAtiva.id,
      tipoArquivo: 'TIPO_EVIDENCIA'
    };
  }

  marcarArquivoParaAssinar(evento: any, arquivo: any) {

    const caminho = arquivo.dsArquivo;;
    const idDocumento = arquivo.idArquivo;

    if (evento.checked) {
      this.incluirArquivoNasOpcoesAssinatura(caminho);
      this.incluirArquivoNosDadosDoCallBackAssinatura(idDocumento);
    } else {
      this.removerArquivoDasOpcoesAssinatura(caminho);
      this.removerArquivoDosDadosDoCallBackAssinatura(idDocumento);
    }
  }

  private incluirArquivoNasOpcoesAssinatura(caminho: string) {
    this.opcoes.arquivos.push(caminho);
  }
  private removerArquivoDasOpcoesAssinatura(caminho: string) {
    this.opcoes.arquivos = this.opcoes.arquivos.filter(c => {
      return caminho !== c;
    });
  }

  private incluirArquivoNosDadosDoCallBackAssinatura(id: any) {
    
    this.opcoes.dadosBackEndCallBack.push({
      idPca: this.PCAAtiva.id,
      idDocumento: id,
      cpfAssinante: this.formatarCpf(this.usuarioLogado.dadosUsuario[0].cpf),
      perfil: this.usuarioService.obterDadosUsuario().perfil
    });
    
  }
  private removerArquivoDosDadosDoCallBackAssinatura(arquivo: any) {
    this.opcoes.dadosBackEndCallBack = this.opcoes.dadosBackEndCallBack.filter(a => {
      return a.idDocumento !== arquivo.idArquivo;
    });
  }

  private formatarCpf(valor) {
    return valor.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, "\$1.\$2.\$3\-\$4");
  }

  sucesso(evento: any) {
    this.inicarOpcoesAssinatura();
    // this.carregarModal();
    // console.log(evento);
    console.log('Assinatura realizada com sucesso.');
    this.carregarListaArquivoEvidencia(this.idQuestaoResposta);


  }

  isAbilitarBotaoAssinatura() {
    return this.opcoes.arquivos.length > 0;
  }

}



// WEBPACK FOOTER //
// ./src/pages/modais/modal-lista-evidencia/modal-lista-evidencia.ts